module.exports = __webpack_public_path__ + "static/media/vertexFax.128f2c69.svg";